import React from 'react';
import { CheckCircle, Circle, Clock, Calendar, MapPin, Truck, Navigation } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

const TrackingTimeline = ({ trackingEvents }) => {
  const getEventIcon = (status) => {
    const lowerStatus = status.toLowerCase();
    
    if (lowerStatus.includes('delivered')) return <CheckCircle className="w-4 h-4 text-green-600" />;
    if (lowerStatus.includes('out for delivery')) return <MapPin className="w-4 h-4 text-blue-600" />;
    if (lowerStatus.includes('transit') || lowerStatus.includes('departed')) return <Navigation className="w-4 h-4 text-purple-600" />;
    if (lowerStatus.includes('picked') || lowerStatus.includes('collected')) return <Truck className="w-4 h-4 text-orange-600" />;
    if (lowerStatus.includes('scheduled')) return <Calendar className="w-4 h-4 text-yellow-600" />;
    
    return <Circle className="w-4 h-4 text-gray-500" />;
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return {
      date: date.toLocaleDateString('en-US', { 
        month: 'short', 
        day: 'numeric',
        year: date.getFullYear() !== new Date().getFullYear() ? 'numeric' : undefined
      }),
      time: date.toLocaleTimeString('en-US', { 
        hour: 'numeric', 
        minute: '2-digit', 
        hour12: true 
      })
    };
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center space-x-2">
          <Clock className="w-5 h-5 text-orange-500" />
          <span>Tracking History</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4 max-h-96 overflow-y-auto">
          {trackingEvents.map((event, index) => {
            const { date, time } = formatDateTime(event.timestamp);
            
            return (
              <div key={index} className="flex items-start space-x-4 pb-4 border-b border-gray-100 last:border-b-0">
                {/* Icon */}
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center">
                  {getEventIcon(event.status)}
                </div>
                
                {/* Content */}
                <div className="flex-grow min-w-0">
                  <div className="flex items-start justify-between">
                    <div>
                      <h4 className="font-medium text-gray-900">{event.status}</h4>
                      <p className="text-sm text-gray-600 mt-1">{event.description}</p>
                      <div className="flex items-center space-x-2 mt-2 text-xs text-gray-500">
                        <MapPin className="w-3 h-3" />
                        <span>{event.location}</span>
                      </div>
                    </div>
                    <div className="text-right text-xs text-gray-500 flex-shrink-0 ml-4">
                      <div>{date}</div>
                      <div>{time}</div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

      </CardContent>
    </Card>
  );
};

export default TrackingTimeline;